/* import __COLOCATED_TEMPLATE__ from './follow-guidance.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    guidelinesCount: number;
  };
}

export default class FollowGuidance extends Component<Signature> {
  @service declare appService: AppService;

  get manageGuidanceRoute() {
    return this.appService.app.isStandaloneApp
      ? 'apps.app.standalone.guidance'
      : 'apps.app.automation.fin-ai-agent.guidance';
  }

  get manageIdentityRoute() {
    return this.appService.app.isStandaloneApp
      ? 'apps.app.settings.ai-automation.fin-ai-agent'
      : 'apps.app.automation.fin-ai-agent.settings';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::FollowGuidance': typeof FollowGuidance;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/follow-guidance': typeof FollowGuidance;
  }
}
